module.exports = __webpack_public_path__ + "static/media/22.082e26de.mp3";